import React from "react";
import styled from "styled-components"
import { EColor } from "../../styleConstants";
import { breakPoint, rem, styleReset } from "../styleUtils";

const DividerHR = styled.hr`
    ${styleReset}
    border-bottom: 1px solid ${EColor.MarlinGray};
    width: 100%;
`

export default function Divider ({

}: {

}) {
    return (
        <DividerHR/>
    )
}